export class Objective {
  id: number
  name: string
  average_net_tuition: number
  cost_per_credit_hour: number
  average_credits_per_student: number
  average_student_head_count: number
  typical_enrollment_rate: number
  typical_melt_rate: number
  typical_persistence_rates: number
  typical_stopout_recovery_rate: number
  payment_type: string
  population: string
  general_audience_description: string
  general_audience_description_notes: string
  client_name: string
  overall_campaign_goals: string
  population_segment_id: string
  list_size: number
  list_age_start_date: string | null
  list_age_end_date: string | null
  list_type: string
  lookback_window: number | null
  academic_calendar_url: string

  constructor() {
    this.id = -1
    this.name = ""
    this.average_net_tuition = 0
    this.cost_per_credit_hour = 0
    this.average_credits_per_student = 0
    this.average_student_head_count = 0
    this.typical_enrollment_rate = 0
    this.typical_melt_rate = 0
    this.typical_persistence_rates = 0
    this.typical_stopout_recovery_rate = 0
    this.payment_type = ""
    this.population = ""
    this.general_audience_description = ""
    this.general_audience_description_notes = ""
    this.client_name = ""
    this.overall_campaign_goals = ""
    this.population_segment_id = ""
    this.list_size = 0
    this.list_age_start_date = null
    this.list_age_end_date = null
    this.list_type = ""
    this.lookback_window = null
    this.academic_calendar_url = ""
  }
}
